<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_1_' + this.id]">
    <div>
      <h1>C'est l'heure de la visite !</h1>
      <p>
        Ça y est, c'est en place ! Tu peux maintenant voir l'ensemble du camp, construit par d'autres scouts, guides,
        éclaireurs et éclaireuses !
      </p>
    </div>

    <div v-on:keyup.esc="toggleFullscreen" class="campmap-wrapper" ref="campmapwrapper" :style="style_attr">
      <div class="zoom-hint">Ctrl + ⬍ = zoom</div>
      <div class="zoomwrapper">
        <button ref="fsbutton" @click="toggleFullscreen" class="toggle-fullscreen"></button>
        <button ref="zoominbtn" @click="() => zoom(40)" class="zoom-in">+</button>
        <button ref="zoomoutbtn" @click="() => zoom(-40)" class="zoom-out">−</button>
        <button ref="rstzoombtn" @click="resetZoom" class="rst-zoom">[1:1]</button>
      </div>
      <div class="shadow-wrapper" ref="shadowwrapper">
        <div class="campmap" ref="campmap" @mousedown="startDrag" @mouseup="stopDrag">
          <div
            v-for="img in images"
            :key="img.id"
            :class="['campdiv campdiv_' + img.x + '_' + img.y]"
            :ref="['tile_' + img.x + '_' + img.y]"
          >
            <div
              v-if="img.x == 0 && img.y == 0"
              :class="['camptile camptile_' + img.x + '_' + img.y]"
              draggable="false"
            >
              Kraal
            </div>
            <div v-else-if="img.fake" :class="['camptile camptile_' + img.x + '_' + img.y]" draggable="false"></div>
            <img
              v-else
              :src="img.img_url"
              alt=" "
              @error="hideImg"
              :class="['camptile camptile_' + img.x + '_' + img.y]"
              draggable="false"
            />
          </div>
        </div>
      </div>
    </div>

    <div>
      <NextButton :url="'/immersion01/' + (this.id + 1)" :text="'Étape suivante'" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Service from "@/services/drawService";
import NextButton from "@/components/NextButton.vue";

export default {
  name: "IM_1_8",
  data: function () {
    return {
      id: 8,
      images: {},
      style_attr: { xs: 0, ys: 0 },
      mousepos: [0, 0],
      dragging: false
    };
  },

  methods: {
    toggleFullscreen: function () {
      this.$refs.fsbutton.classList.toggle("fullscreen");
      // Make wrapper fullscreen
      this.$refs.campmapwrapper.classList.toggle("fullscreen");
      this.$refs.shadowwrapper.classList.toggle("fullscreen");
      // Make map fullscreen
      this.$refs.campmap.classList.toggle("fullscreen");
      this.$el.querySelector(".campdiv_0_0").scrollIntoView({ block: "center", inline: "center" });
    },
    hideImg: function (e) {
      e.target.style.display = "none";
    },
    scroll: function (e) {
      if (e.ctrlKey) {
        e.preventDefault();
        e.stopPropagation();
        if (e.deltaY > 0) {
          this.zoom(-10, true);
        }
        if (e.deltaY < 0) {
          this.zoom(10, true);
        }
      }
    },
    zoom: function (pxls, scroll) {
      const pt = this.getPointedTile();
      const ct = this.getCenterTile();
      const [beforeX, beforeY] = [pt.offsetLeft, pt.offsetTop];
      const root = document.documentElement;
      const tilesize = getComputedStyle(root).getPropertyValue("--tilesize");
      const valuetilesize = parseInt(tilesize.substring(0, tilesize.length - 2));
      const new_tilesize = valuetilesize + pxls;
      if (new_tilesize < 600 && new_tilesize > 40) {
        root.style.setProperty("--tilesize", `${new_tilesize}px`);
        const [afterX, afterY] = [pt.offsetLeft, pt.offsetTop];
        if (scroll) {
          this.$refs.shadowwrapper.scrollLeft += afterX - beforeX;
          this.$refs.shadowwrapper.scrollTop += afterY - beforeY;
        } else {
          ct.scrollIntoView({ block: "center", inline: "center" });
        }
      }
    },
    resetZoom: function () {
      const root = document.documentElement;
      const ct = this.getCenterTile();
      root.style.setProperty("--tilesize", "200px");
      ct.scrollIntoView({ block: "center", inline: "center" });
    },
    startDrag: function (e) {
      this.dragging = true;
      this.mousepos = [e.clientX, e.clientY];
      this.$refs.shadowwrapper.classList.add("grabbing");
    },
    stopDrag: function () {
      this.dragging = false;
      this.$refs.shadowwrapper.classList.remove("grabbing");
    },
    getCenterTile: function () {
      const el = this.$refs.shadowwrapper;
      const rect = el.getBoundingClientRect();
      return document.elementFromPoint(rect.x + rect.width / 2, rect.y + rect.height / 2);
    },
    getPointedTile: function () {
      const x = window.event.clientX;
      const y = window.event.clientY;
      return document.elementFromPoint(x, y);
    }
  },

  created() {
    // Press escape to leave "fullscreen"
    document.addEventListener("keyup", (e) => {
      if (e.keyCode === 27 && this.$refs.campmapwrapper.classList.contains("fullscreen")) {
        this.toggleFullscreen();
      }
    });

    document.addEventListener("mousemove", (e) => {
      if (this.dragging) {
        const scroller = this.$refs.shadowwrapper;
        const offsetX = this.mousepos[0] - e.clientX;
        const offsetY = this.mousepos[1] - e.clientY;
        this.mousepos = [e.clientX, e.clientY];
        scroller.scrollLeft += offsetX;
        scroller.scrollTop += offsetY;
      }
    });
  },

  mounted() {
    Service.getAllTiles()
      .then((e) => {
        this.images = e.images;
        this.style_attr = e.style_attr;
        this.$nextTick(() => {
          this.$el.querySelector(".campdiv_0_0").scrollIntoView({ block: "center", inline: "center" });

          // Setup zoom via Ctrl+scroll
          this.$refs.campmapwrapper.addEventListener("wheel", (e) => this.scroll(e), { capture: true, passive: false });
        });
      })
      .catch(() => {});
  },
  components: {
    NextButton
  }
};
</script>

<style lang="scss">
:root {
  --tilesize: 200px;
  --borderclr: #be9e71;
}

@media (min-width: 550px) {
  .IM_1_8 {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 50px;
    height: calc(100vh - 60px);
  }
}

@media (max-width: 550px) {
  .IM_1_8 {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 50px;
    height: calc(100vh - 120px);
  }
}

.IM_1_8 > * {
  flex-grow: 0;
}

.campmap-wrapper {
  position: relative;
  width: 90vw;
  height: calc(100vh - 200px);
  background-color: #b0bc21;
}

.campmap-wrapper::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  box-shadow: inset 0px 0px 30px -10px #000;
  z-index: 100;
  pointer-events: none;
}

.shadow-wrapper::-webkit-scrollbar {
  width: 0px; /* Remove scrollbar space */
  background: #505c01; /* Optional: just make scrollbar invisible */
}

.shadow-wrapper {
  z-index: 50;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow: scroll;
  scrollbar-width: none;
  background-color: #b0bc21;
  display: flex;
  cursor: grabbing;
}

.campmap-wrapper.fullscreen {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
}

.campmap {
  display: grid;
  margin: auto;
  grid-template-columns: repeat(var(--cols), var(--tilesize));
  grid-template-rows: repeat(var(--rows), var(--tilesize));
  background-color: #b0bc21;
  user-select: none;
  padding: 1000px;
  box-shadow: inset 0px 0px 2000px 700px #404c01;
}

.camptile {
  width: var(--tilesize);
  height: var(--tilesize);
  background-color: #b0bc21;
  pointer-events: none;
  padding: 0px;
  margin: 0px;
  display: block;
  user-select: none;
  box-sizing: content-box;
}

img.camptile[alt] {
  width: var(--tilesize);
  height: var(--tilesize);
  padding: 0px;
}

.camptile_0_0 {
  --fsize: calc(var(--tilesize) / 8);
  color: #000;
  font-weight: bold;
  font-size: var(--fsize);
  padding-top: calc(var(--tilesize) / 2 - var(--fsize) / 1.5);
}

.campdiv {
  width: var(--tilesize);
  height: var(--tilesize);
  margin: 0;
  padding: 0;
  border-top: 1px solid var(--borderclr);
  border-left: 1px solid var(--borderclr);
  box-sizing: content-box;
}

.toggle-fullscreen {
  outline: none;
  margin-bottom: 10px;

  &:focus,
  &:active {
    outline: none;
  }

  &::before {
    content: "⬈";
  }

  &.fullscreen::before {
    content: "⬋";
  }
}

.zoomwrapper {
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 30px;
  top: 20px;
  opacity: 0.1;
  z-index: 200;
  transition: opacity 0.3s linear;

  button {
    color: white;
    background-color: #5e2a57;
    width: 55px;
    height: 55px;
    font-weight: bold;
    font-size: 30px;
    padding-bottom: 1em;
    padding-top: 0px;
    outline: none;
    border-radius: 10px;
  }

  &:hover {
    opacity: 1;
  }

  button:focus,
  button:active {
    outline: none;
  }

  .rst-zoom {
    font-size: 18px;
    text-align: center;
    padding-top: 11px;
  }
}

.zoom-hint {
  position: absolute;
  top: 10px;
  left: 15px;
  z-index: 200;
  font-size: 26px;
  opacity: 0.1;
  color: black;
  font-weight: bold;
  padding: 2px 20px 5px 20px;
  border-radius: 10px;
  transition: opacity 0.4s linear, background-color 0.4s linear;

  &:hover {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.4);
  }
}

.next-btn .box {
  position: static;
  margin: 10px auto;
}

.next-btn a {
  text-decoration: none !important;
}

h1 {
  margin-top: 40px !important;
}
</style>
